/**
 * VideoControl class to manage video play and pause actions on cover blocks.
 */
class VideoControl {
	/**
	 * Constructor to initialize the VideoControl class.
	 *
	 * @param {HTMLElement} coverBlock - The cover block element that contains the video.
	 */
	constructor( coverBlock ) {
		this.coverBlock = coverBlock;
		this.videoElement = coverBlock.querySelector( 'video' );
		this.controlIcon = null;

		if ( ! IsPrefersReducedMotion ) {
			this.videoElement.play();
		}

		if ( ! this.coverBlock.querySelector( '.video-control-icon' ) ) {
			this.createControlIcon();
			this.attachEventListeners();
		}
	}

	/**
	 * Creates a control icon to toggle video play and pause.
	 */
	createControlIcon() {
		this.controlIcon = document.createElement( 'button' );
		this.controlIcon.ariaLabel = 'Toggle video play and pause';
		if ( this.videoElement.paused ) {
			this.controlIcon.className = 'video-control-icon play'; // Start with 'play' icon
		} else {
			this.controlIcon.className = 'video-control-icon pause'; // Start with 'pause' icon
		}
		this.coverBlock.appendChild( this.controlIcon );
	}

	/**
	 * Attaches event listeners to the control icon and the video element.
	 */
	attachEventListeners() {
		this.controlIcon.addEventListener( 'click', () => {
			if ( this.videoElement.paused ) {
				this.videoElement.play();
				this.controlIcon.classList.remove( 'play' );
				this.controlIcon.classList.add( 'pause' );
			} else {
				this.videoElement.pause();
				this.controlIcon.classList.remove( 'pause' );
				this.controlIcon.classList.add( 'play' );
			}
		} );
	}
}

/**
 * Initializes video controls on all cover blocks that contain a video element and are marked with 'is-controls-enabled'.
 */
function initVideoControls() {
	const coverBlocks = document.querySelectorAll(
		'.wp-block-cover.is-controls-enabled',
	);
	coverBlocks.forEach( ( coverBlock ) => {
		if ( coverBlock.querySelector( 'video' ) ) {
			new VideoControl( coverBlock );
		}
	} );
}

// Initialize video controls when the DOM is ready.
document.addEventListener( 'DOMContentLoaded', initVideoControls );
